<template>
	<div>
		<b-card>
			<b-card-text>
				<b-button
					:class="isDrillDown ? 'td-btn-blue' : 'td-btn-outline-blue'"
					pill
					@click="isDrillDown = !isDrillDown"
				>
					<b-icon icon="sort-down" />
					Drill Down Data
				</b-button>

				<b-row class="mx-0 my-3" v-show="!isDrillDown" align-v="center">
					<label class="font-weight-bold">Pilih Kategori Axis : </label>
					<b-col cols="3">
						<b-form-select v-model="selectedAxis" size="sm">
							<b-form-select-option :value="null" disabled>
								-- Pilih salah satu kategori --
							</b-form-select-option>
							<b-form-select-option
								v-for="(item, idx) in axisCategories"
								:value="item.key"
								:key="idx"
							>
								{{ item.value }}
							</b-form-select-option>
						</b-form-select>
					</b-col>
				</b-row>

				<b-row
					class="mx-0"
					align-v="center"
					v-show="selectedAxis && !isDrillDown"
				>
					<label class="font-weight-bold"> Daftar Series Data : </label>
					<b-col cols="3">
						<b-button
							class="td-btn-blue"
							v-if="!isSeriesList"
							@click="isSeriesList = !isSeriesList"
							pill
							size="sm"
						>
							Tampilkan
						</b-button>
						<b-button
							v-if="isSeriesList"
							class="td-btn-red"
							@click="isSeriesList = !isSeriesList"
							pill
							size="sm"
						>
							Tutup
						</b-button>
					</b-col>
				</b-row>

				<b-card
					class="my-3 w-50"
					v-show="isSeriesList && !isDrillDown"
					style="border: 1px solid rgb(23, 162, 184) !important"
				>
					<div class="text-right mb-3">
						<b-button
							class="td-btn-blue mr-1"
							pill
							size="sm"
							@click="onClickSelectSeriesList('selectAll')"
						>
							Select All
						</b-button>
						<b-button
							class="td-btn-outline-red"
							pill
							size="sm"
							@click="onClickSelectSeriesList('unselectAll')"
						>
							Unselect All
						</b-button>
					</div>

					<div class="mb-3" style="font-size: 0.85rem">
						<span style="font-weight: bold">Struktur:</span>
						<br />
						<span>{{ dataSeriesStructure }}</span>
					</div>

					<b-list-group
						class="m-0"
						style="
							max-height: 250px;
							overflow-y: auto;
							border: 1px solid rgba(0, 0, 0, 0.2);
						"
					>
						<b-list-group-item
							v-for="(item, idx) in seriesList"
							:key="idx"
							class="py-2 px-3"
						>
							<b-row class="p-0">
								<b-col md="10" style="word-wrap: break-word">
									<template v-for="(item2, idx2) in item">
										<template v-if="idx2 > 0">
											-
											{{ capitalizeEachWord(item2[2]) }}
										</template>
										<template v-else>
											{{ capitalizeEachWord(item2[2]) }}
										</template>
									</template>
								</b-col>
								<b-col h-align="right" md="2">
									<b-form-checkbox
										v-model="seriesListVisibility[idx]"
										class="ml-2"
										switch
									>
									</b-form-checkbox>
								</b-col>
							</b-row>
						</b-list-group-item>
					</b-list-group>

					<div class="mt-2" style="font-size: 0.85rem; font-weight: bold">
						Jumlah item terpilih: {{ seriesListVisibilityLen }} dari
						{{ seriesListLen }}
					</div>
				</b-card>

				<b-card v-show="isDrillDown" no-body class="my-3" style="width: 400px">
					<b-card-header class="td-bg-blue text-light font-weight-bold">
						<b-icon icon="layout-three-columns" rotate="90" />
						Drill Down Level
					</b-card-header>

					<b-card-body
						id="line-chart-dropzone-item"
						@drop="onDrop($event)"
						@dragover.prevent
						@dragenter.prevent
						class="pt-3 pb-0"
					>
						<div
							:id="'line-chart-dropzone-item-fields-' + item"
							class="
								td-border-grey td-border-solid td-border-thin td-cursor-move
								py-2
								px-2
								my-2
								draggable-fields
							"
							v-for="item in drilldownDimensions"
							:key="item"
							:data-value="item"
							draggable
							@dragstart="startDrag($event)"
						>
							<b-icon
								class="mr-1 td-text-grey"
								icon="grid-fill"
								font-scale="0.8"
							/>
							<template v-if="item === 'indicator'"> Indikator </template>
							<template v-else-if="item === 'region'"> Wilayah </template>
							<template v-else-if="item === 'period'"> Periode </template>

							<template v-else-if="item.startsWith('category')">
								{{ capitalizeEachWord(choosenDimensions[item].name) }}
							</template>
						</div>
					</b-card-body>

					<b-card-text class="text-right" style="padding: 0.5rem 1.25rem">
						<b-button
							class="td-btn-outline-blue mr-1"
							pill
							@click="resetDrillDownLevel"
						>
							Reset <b-icon class="ml-1" icon="arrow-counterclockwise" />
						</b-button>
						<b-button class="td-btn-blue" pill @click="updateDrillDownLevel">
							Update <b-icon class="ml-1" icon="check-circle" />
						</b-button>
					</b-card-text>
				</b-card>

				<b-row class="text-right">
					<b-col />
					<b-col>
						<b-button-group class="mr-3">
							<b-button
								:class="
									lineMode === 'grouped' ? 'td-btn-teal' : 'td-btn-outline-teal'
								"
								:disabled="!isDrillDown && selectedAxis === null"
								@click="lineMode = 'grouped'"
							>
								<b-icon icon="ui-radios-grid" />
								Grouped
							</b-button>
							<b-button
								:class="
									lineMode === 'stacked' ? 'td-btn-teal' : 'td-btn-outline-teal'
								"
								v-show="!isDrillDown"
								:disabled="!isDrillDown && selectedAxis === null"
								@click="lineMode = 'stacked'"
							>
								<b-icon icon="layers-fill" />
								Stacked
							</b-button>
							<b-button
								:class="
									lineMode === 'expanded'
										? 'td-btn-teal'
										: 'td-btn-outline-teal'
								"
								:disabled="!isDrillDown && selectedAxis === null"
								v-show="!isDrillDown"
								@click="lineMode = 'expanded'"
							>
								<b-icon icon="arrows-fullscreen" />
								Expanded
							</b-button>
						</b-button-group>

						<b-button
							:class="
								(isSmoothed ? 'td-btn-teal' : 'td-btn-outline-teal') + ' mr-3'
							"
							:disabled="!isDrillDown && selectedAxis === null"
							@click="isSmoothed = !isSmoothed"
						>
							<b-icon icon="alt" />
							Smoothed
						</b-button>

						<b-button
							:class="isInverted ? 'td-btn-teal' : 'td-btn-outline-teal'"
							:disabled="!isDrillDown && selectedAxis === null"
							@click="isInverted = !isInverted"
						>
							<b-icon
								:icon="isInverted ? 'arrow-down-up' : 'arrow-left-right'"
							/>
							Inverted
						</b-button>
					</b-col>
				</b-row>

				<div id="line-chart" class="w-100 mt-4" style="height: auto"></div>
			</b-card-text>
		</b-card>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
var Highcharts = require("highcharts");
require("highcharts/modules/drilldown")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
import StreamgraphModule from "highcharts/modules/streamgraph";
StreamgraphModule(Highcharts);
import utils from "../../../../../../../utils/TabelDinamisUtils";

//local registration for output component
export default {
	name: "VisualizationLineChart",
	data() {
		return {
			selectedAxis: null,
			selectedSecondAxis: null,
			categories: [],
			seriesList: [],
			seriesListVisibility: [],
			seriesData: [],
			isSeriesList: false,
			tempData: [],
			backupData: [],
			lineChart: null,
			lineMode: "grouped",
			isInverted: false,
			isSmoothed: false,
			isDrillDown: false,
			drilldownDimensions: [],
			backupDrilldownDimensions: [],
		};
	},
	props: ["choosenDimensions", "choosenData", "datasetName"],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {
		lineChartType() {
			if (this.isSmoothed) {
				return "spline";
			} else {
				return "line";
			}
		},
		axisCategories() {
			return Object.entries(this.choosenDimensions)
				.map(([k, v]) => {
					return { key: k, value: utils.capitalizeEachWord(v.name) };
				})
				.filter((v) => {
					return v.value !== "";
				});
		},
		seriesListLen() {
			return this.seriesList.length;
		},
		seriesListVisibilityLen() {
			return this.seriesListVisibility.filter((v) => {
				return v === true;
			}).length;
		},
		dataSeriesStructure() {
			let len;
			let temp = "";

			if (this.selectedSecondAxis !== null) {
				len = this.selectedSecondAxis.length;

				if (len > 0) {
					for (let i = 0; i < len; i++) {
						temp +=
							"[" +
							utils.capitalizeEachWord(
								this.choosenDimensions[this.selectedSecondAxis[i]].name
							) +
							"]";
						if (i < len - 1) {
							temp += " - ";
						}
					}
				}
			}

			return temp;
		},
		drilldownDimensionsLen() {
			return this.drilldownDimensions.length;
		},
	},
	watch: {
		choosenData(newVal, oldVal) {
			if (newVal !== oldVal) {
				if (this.lineChart !== null) {
					this.lineChart.destroy();
					this.lineChart = null;
				}
				this.backupData = [];
				this.tempData = [];
				this.selectedAxis = null;
				this.seriesList = [];
				this.isSeriesList = false;
				this.selectedSecondAxis = null;
				this.isDrillDown = false;
				this.initializeDrillDownLevel();
			}
		},
		selectedAxis(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.lineMode = "grouped";
				this.isInverted = false;
				this.isSmoothed = false;

				if (newVal !== null) {
					this.initializeTempData();
					this.setCategories();
					this.setSelectedSecondAxis();

					const selectedSecondAxisCategoryArray = [];
					this.setSelectedSecondAxisCategoryArray(
						selectedSecondAxisCategoryArray
					);

					let getCombination = function (array, prefix) {
						prefix = prefix || "";

						if (!array.length) {
							return prefix.slice(0, -1);
						}

						var result = array[0].reduce(function (result, value) {
							return result.concat(
								getCombination(array.slice(1), prefix + value + "¸")
							);
						}, []);

						return result;
					};

					let selectedSecondAxisCategoryArrayCombination = getCombination(
						selectedSecondAxisCategoryArray
					);

					this.seriesList = Object.values(
						selectedSecondAxisCategoryArrayCombination
					).map((val) => {
						return this.setFilters(val);
					});

					this.seriesListVisibility = [];
					for (let i = 0; i < this.seriesListLen; i++) {
						this.seriesListVisibility[i] = true;
					}

					this.seriesData = [];
					Object.values(this.seriesList).forEach((value) => {
						let itemSeriesData = {};
						let dataArr = [];

						Object.values(
							this.choosenDimensions[this.selectedAxis].selectedItem
						).forEach((value2) => {
							let temp = [];
							temp.push(this.selectedAxis);
							temp.push("" + value2.id);

							let temp2 = JSON.parse(JSON.stringify(value));
							temp2.push(temp);

							dataArr.push(this.validateTempData(temp2));
						});

						let nameSeries = "";
						Object.entries(value).forEach(([key3, value3]) => {
							if (key3 > 0) {
								nameSeries += "-" + utils.capitalizeEachWord(value3[2]);
							} else {
								nameSeries += utils.capitalizeEachWord(value3[2]);
							}
						});

						itemSeriesData = {
							name: nameSeries,
							data: dataArr,
						};
						this.seriesData.push(itemSeriesData);
					});

					if (this.lineChart !== null) {
						this.lineChart.destroy();
					}

					this.generateLineChart();
				} else if (newVal === null) {
					this.resetCategories();
				}
			}
		},
		seriesListVisibility: {
			deep: true,
			handler() {
				this.generateLineChart();
			},
		},
		lineMode: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal && this.lineChart !== null) {
					switch (newVal) {
						case "grouped":
							this.lineChart.update(
								{
									tooltip: {
										shared: true,
										pointFormat:
											'<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.0f}</b><br/>',
									},
									plotOptions: {
										series: {
											stacking: null,
										},
									},
								},
								false
							);

							break;
						case "stacked":
							this.lineChart.update(
								{
									tooltip: {
										shared: true,
										pointFormat:
											'<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.0f}</b><br/>',
									},
									plotOptions: {
										series: {
											stacking: "normal",
										},
									},
								},
								false
							);

							break;
						case "expanded":
							this.lineChart.update(
								{
									chart: {
										type: "line",
									},
									tooltip: {
										pointFormat:
											'<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f})<br/>',
									},
									plotOptions: {
										series: {
											stacking: "percent",
										},
									},
								},
								false
							);

							break;
					}

					this.lineChart.redraw();
				}
			},
		},
		isInverted: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal && this.lineChart !== null) {
					this.lineChart.update(
						{
							chart: {
								inverted: newVal,
							},
						},
						false
					);

					this.lineChart.redraw();
				}
			},
		},
		isSmoothed: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal && this.lineChart !== null) {
					this.lineChart.update(
						{
							chart: {
								type: this.lineChartType,
							},
						},
						false
					);

					this.lineChart.redraw();
				}
			},
		},
		isDrillDown(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.isGrouped = true;
				this.initializeTempData();
				this.generateLineChart();
			}
		},
	},
	methods: {
		capitalizeEachWord(str) {
			return utils.capitalizeEachWord(str);
		},
		startDrag(evt) {
			evt.dataTransfer.dropEffect = "move";
			evt.dataTransfer.effectAllowed = "move";
			evt.dataTransfer.setData("item", evt.target.id);
		},
		onDrop(evt) {
			evt.preventDefault();
			let item = evt.dataTransfer.getData("item");

			if (evt.target.id === "line-chart-dropzone-item") {
				document
					.getElementById(evt.target.id)
					.appendChild(document.getElementById(item));
			} else {
				if (evt.target.id !== item) {
					if (
						evt.currentTarget.id !== document.getElementById(item).parentNode.id
					) {
						document
							.getElementById(evt.currentTarget.id)
							.insertBefore(
								document.getElementById(item),
								document.getElementById(evt.target.id)
							);
					} else {
						let childrenNodesDropzone = document.getElementById(
							evt.currentTarget.id
						).children;

						let idxItem = Array.from(childrenNodesDropzone).indexOf(
							document.getElementById(item)
						);

						let idxTargetId = Array.from(childrenNodesDropzone).indexOf(
							document.getElementById(evt.target.id)
						);

						if (idxItem < idxTargetId) {
							if (idxTargetId === childrenNodesDropzone.length - 1) {
								document
									.getElementById(evt.currentTarget.id)
									.insertBefore(document.getElementById(item), null);
							} else {
								document
									.getElementById(evt.currentTarget.id)
									.insertBefore(
										document.getElementById(item),
										document.getElementById(
											childrenNodesDropzone[idxTargetId + 1].id
										)
									);
							}
						} else {
							document
								.getElementById(evt.currentTarget.id)
								.insertBefore(
									document.getElementById(item),
									document.getElementById(childrenNodesDropzone[idxTargetId].id)
								);
						}
					}
				}
			}
		},
		initializeTempData() {
			//set temp data by transform response.data if backupdata hasnot been set, else temp data is assigned by backup data
			if (this.backupData.length === 0) {
				let tempData = Object.values(this.choosenData).map((value) => {
					let data = {
						value: value.value,
						period: value.period,
						region: value.region.itemCategoryId,
						indicator: value.indicator.indicatorId,
					};
					Object.keys(value).forEach((key) => {
						if (
							key.startsWith("itemCategory") &&
							value[key].itemCategoryId > 0
						) {
							let itemCategory = {
								["category" + key.slice(key.length - 1)]:
									value[key].itemCategoryId,
							};
							data = { ...data, ...itemCategory };
						}
					});

					return data;
				});

				this.tempData = tempData;
				this.backupData = JSON.parse(JSON.stringify(this.tempData));
			} else {
				this.tempData = JSON.parse(JSON.stringify(this.backupData));
			}
		},
		initializeDrillDownLevel() {
			this.drilldownDimensions = [];
			this.drilldownDimensions.push("indicator");

			Object.keys(this.choosenDimensions).forEach((key) => {
				if (
					key.startsWith("category") &&
					this.choosenDimensions[key].selectedItem.length > 0
				) {
					this.drilldownDimensions.push(key);
				}
			});

			this.drilldownDimensions.push("region");
			this.drilldownDimensions.push("period");

			this.backupDrilldownDimensions = this.drilldownDimensions;
		},
		setCategories() {
			this.categories = this.choosenDimensions[
				this.selectedAxis
			].selectedItem.map((item) => {
				return item.name;
			});
		},
		resetCategories() {
			this.categories = [];
		},
		setSelectedSecondAxis() {
			this.selectedSecondAxis = [];

			Object.keys(this.choosenDimensions).forEach((key) => {
				if (
					this.choosenDimensions[key].name !== "" &&
					key !== this.selectedAxis
				) {
					this.selectedSecondAxis.push(key);
				}
			});
		},
		setSelectedSecondAxisCategoryArray(val) {
			return Object.values(this.selectedSecondAxis).forEach((value) => {
				const dimensionItems = this.choosenDimensions[value].selectedItem.map(
					(item) => {
						return value + "—" + item.id + "—" + item.name;
					}
				);

				val.push(dimensionItems);
			});
		},
		setFilters(val) {
			return Object.values(val.split("¸")).map((value) => {
				return value.split("—");
			});
		},
		validateTempData(filters) {
			let dataFound = null;

			for (let i in this.tempData) {
				let value = this.tempData[i];
				let result = "success";

				for (let i = 0, filtersLen = filters.length; i < filtersLen; i++) {
					if (filters[i][0] === "period") {
						if (value[filters[i][0]] !== filters[i][1]) {
							result = "fail";
							break;
						}
					} else {
						if (value[filters[i][0]] !== parseInt(filters[i][1])) {
							result = "fail";
							break;
						}
					}
				}

				if (result === "success") {
					dataFound = value.value;

					delete this.tempData[i];
					break;
				}
			}

			return dataFound;
		},
		onClickSelectSeriesList(option) {
			let len = this.seriesListVisibility.length;
			let temp = [];

			switch (option) {
				case "selectAll":
					for (let i = 0; i < len; i++) {
						temp[i] = true;
					}
					break;
				case "unselectAll":
					for (let i = 0; i < len; i++) {
						temp[i] = false;
					}
					break;
			}

			this.seriesListVisibility = JSON.parse(JSON.stringify(temp));
		},
		generateLineChart() {
			let tempSeriesData = [];
			let seriesDataAndDrillDown = [];

			if (this.isDrillDown) {
				this.setSeriesDataAndDrillDown(seriesDataAndDrillDown);
			} else {
				Object.keys(this.seriesListVisibility).forEach((key) => {
					if (this.seriesListVisibility[key]) {
						tempSeriesData.push(this.seriesData[key]);
					}
				});
			}

			this.lineChart = Highcharts.chart("line-chart", {
				chart: {
					type: this.lineChartType,
					inverted: this.isInverted,
					borderColor: "grey",
					borderWidth: 1,
					borderRadius: 10,
					spacing: [25, 30, 25, 30],
					zoomType: "xy",
					height: 500,
				},
				title: {
					text: this.datasetName,
				},
				subtitle: {
					text: "",
				},
				xAxis: {
					categories: this.isDrillDown ? null : this.categories,
					title: {
						text: null,
					},
					type: this.isDrillDown ? "category" : null,
				},
				yAxis: {
					title: {
						text: "",
						align: "high",
					},
					labels: {
						overflow: "justify",
					},
				},
				tooltip: {
					shared: true,
				},
				plotOptions: {
					series: {
						stacking:
							this.lineMode === "expanded"
								? "percent"
								: this.lineMode === "stacked"
								? "normal"
								: null,
					},
				},
				legend: {
					// layout: "vertical",
					// align: "right",
					// verticalAlign: "top",
					// x: -40,
					// y: 100,
					maxHeight: 100,
					floating: false,
					borderWidth: 1,
					backgroundColor:
						Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
					shadow: true,
					enabled: this.isDrillDown ? false : true,
				},
				credits: {
					enabled: false,
				},
				series: this.isDrillDown
					? [{ colorByPoint: true, data: seriesDataAndDrillDown[0] }]
					: tempSeriesData,
				drilldown: {
					breadcrumbs: {
						position: {
							align: "right",
						},
					},
					series: this.isDrillDown ? seriesDataAndDrillDown[1] : null,
				},
			});
		},
		setSeriesDataAndDrillDown(seriesDataAndDrillDown) {
			let seriesData = [],
				seriesDrillDown = [],
				transferedData = [];

			for (let i = 0; i < this.drilldownDimensionsLen + 1; i++) {
				if (i === 0) {
					seriesData = this.constructDrillDownSeriesData(
						i,
						this.tempData,
						transferedData
					);
				} else if (i === 1) {
					seriesData.forEach((itemSeries) => {
						let drillDownWrapper = this.constructDrillDownWrapper(
							itemSeries.name,
							itemSeries.drilldown,
							i,
							itemSeries
						);

						transferedData.push(drillDownWrapper);

						delete itemSeries.data;
					});

					seriesDrillDown = [...seriesDrillDown, ...transferedData];
				} else if (i !== 1 && i < this.drilldownDimensionsLen - 1) {
					let tempData = transferedData;
					transferedData = [];

					tempData.forEach((tempItemSeries) => {
						tempItemSeries.data.forEach((itemSeries) => {
							let drillDownWrapper = this.constructDrillDownWrapper(
								itemSeries.name,
								itemSeries.drilldown,
								i,
								itemSeries
							);

							transferedData.push(drillDownWrapper);

							delete itemSeries.data;
						});
					});

					seriesDrillDown = [...seriesDrillDown, ...transferedData];
				} else if (i === this.drilldownDimensionsLen - 1) {
					let tempData = transferedData;
					transferedData = [];

					tempData.forEach((tempItemSeries) => {
						tempItemSeries.data.forEach((itemSeries) => {
							let drillDownWrapper = this.constructDrillDownWrapper(
								itemSeries.name,
								itemSeries.drilldown,
								i,
								itemSeries
							);

							transferedData.push(drillDownWrapper);

							delete itemSeries.data;
						});
					});

					seriesDrillDown = [...seriesDrillDown, ...transferedData];
				}
			}

			seriesDataAndDrillDown[0] = seriesData;
			seriesDataAndDrillDown[1] = seriesDrillDown;
		},
		constructDrillDownSeriesData(i, originData) {
			let outputData = [];

			this.choosenDimensions[this.drilldownDimensions[i]].selectedItem.forEach(
				(item) => {
					if (i < this.drilldownDimensionsLen - 1) {
						let filteredTempData = (
							i === 0 ? originData : originData.data
						).filter((data) => data[this.drilldownDimensions[i]] === item.id);

						let output = {
							y: filteredTempData.reduce(function (previousVal, currentVal) {
								return (
									previousVal +
									(currentVal.value === "..." ? 0 : currentVal.value)
								);
							}, 0),
							data: filteredTempData,
							name: item.name,
							drilldown:
								i === 0 ? item.id : originData.drilldown + "-" + item.id,
						};

						outputData.push(output);
					} else {
						this.choosenDimensions[
							this.drilldownDimensions[i]
						].selectedItem.forEach((item) => {
							let temp = originData.data.find(
								(data) => data[this.drilldownDimensions[i]] === item.id
							);
							outputData.push([
								item.name,
								temp.value === "..." ? 0 : temp.value,
							]);
						});
					}
				}
			);

			return outputData;
		},
		constructDrillDownWrapper(name, id, i, itemSeries) {
			return {
				colorByPoint: true,
				name: name,
				id: id,
				data: this.constructDrillDownSeriesData(i, itemSeries),
			};
		},
		updateDrillDownLevel() {
			let temp = [];

			let dropzoneItems = document.getElementById(
				"line-chart-dropzone-item"
			).children;

			temp = Object.values(dropzoneItems).map((item) => {
				return item.getAttribute("data-value");
			});

			if (!utils.arraysEqual(temp, this.drilldownDimensions)) {
				this.drilldownDimensions = temp;

				this.generateLineChart();
			}
		},
		resetDrillDownLevel() {
			let temp = [];

			let dropzoneItems = document.getElementById(
				"line-chart-dropzone-item"
			).children;

			temp = Object.values(dropzoneItems).map((item) => {
				return item.getAttribute("data-value");
			});

			if (!utils.arraysEqual(temp, this.backupDrilldownDimensions)) {
				this.drilldownDimensions = [];

				setTimeout(
					function () {
						this.drilldownDimensions = JSON.parse(
							JSON.stringify(this.backupDrilldownDimensions)
						);

						this.generateLineChart();
					}.bind(this),
					0
				);

				/* for (
					let i = 0, backupLen = this.backupDrilldownDimensions.length;
					i < backupLen;
					i++
				) {
					this.$set(
						this.drilldownDimensions,
						i,
						this.backupDrilldownDimensions[i]
					);
				} */

				this.generateLineChart();
			}
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 15-03-2023 -->
